<agr-form [formGroup]="formGroup()">
  <div
    [class.question-container]="question().isVisible || question().isVisible === undefined"
    [class.invalid-required]="getRequiredTag() && isInvalidRequired()"
    class="spacing--margin-bottom spacing--margin-top"
    [attr.data-test]="'question-' + question().controlType"
    [attr.id]="'question-' + question().key"
  >
    @if (question().controlType === 'checkbox') {
      <div class="mat-checkbox-row-wrapper" data-test="checkbox-question-wrapper">
        <section class="example-section" [formGroup]="formGroup()">
          <h4
            class="margin-10"
            [class.invalid-label]="getRequiredTag() && isInvalidRequired()"
            data-test="question-label"
          >
            {{ (question().label | translate).concat(getRequiredTag()) }}
          </h4>
          <div data-test="checkbox-question" class="checkbox-container">
            @for (opt of question().options; track opt.key; let i = $index) {
              <span
                class="checkbox-tooltip-wrapper"
                [matTooltip]="readOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
                [matTooltipDisabled]="!readOnly()"
              >
                <mat-checkbox
                  class="spacing--margin-right checkbox-option"
                  color="primary"
                  [name]="question().key"
                  [(ngModel)]="$any(question()).value[i].selected"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="readOnly() || getFormControl(question().key)?.disabled"
                  (change)="onCheckBoxChange()"
                  [attr.data-test]="'checkbox-option-' + opt.key"
                >
                  <span class="radio-label-content">
                    {{ opt.value | translate }}
                    @if (asCheckBoxQuestion().hasInfoIcon) {
                      <button
                        mat-icon-button
                        class="info-icon"
                        type="button"
                        (click)="onIconClick(opt)"
                        [attr.aria-label]="'info ' + opt.key"
                      >
                        <mat-icon>info_outline</mat-icon>
                      </button>
                    }
                  </span>
                </mat-checkbox>
              </span>
            }
          </div>
        </section>
      </div>
    } @else if (question().controlType === 'warning-message') {
      <div class="mat-input-group-wrapper" data-test="warning-message-question-wrapper">
        <h4
          class="margin-10"
          [class.invalid-label]="getRequiredTag() && isInvalidRequired()"
          data-test="question-label"
        >
          {{ (question().label | translate).concat(getRequiredTag()) }}
        </h4>
        @if (question().description && question().description !== undefined) {
          <p class="description-text" data-test="question-description">
            {{ question().description! | translate }}
          </p>
        }
        @if (asWarningMessageQuestion().showAsRegularText) {
          <p class="warning-message-text" data-test="warning-message-text">
            {{ question().placeholder! | translate }}
          </p>
        } @else {
          <app-alert message="{{ question().placeholder! | translate }}" data-test="warning-message-alert" />
        }
      </div>
    } @else if (question().controlType === 'dropdown' && (question().isVisible || question().isVisible === undefined)) {
      <div class="mat-input-group-wrapper" data-test="dropdown-question-wrapper">
        <h4
          class="margin-10"
          [class.invalid-label]="getRequiredTag() && isInvalidRequired()"
          data-test="question-label"
        >
          {{ (question().label | translate).concat(getRequiredTag()) }}
        </h4>
        @if (question().description && question().description !== undefined) {
          <p class="description-text" data-test="question-description">
            {{ question().description! | translate }}
          </p>
        }
        <mat-form-field
          class="full-width-input"
          data-test="dropdown-question"
          [matTooltip]="readOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [matTooltipDisabled]="!readOnly()"
          [ngClass]="{
            'has-value': formGroup().get(question().key)?.value,
          }"
        >
          @if (!formGroup().get(question().key)?.value) {
            <mat-label>
              {{ question().placeholder || '' | translate }}
            </mat-label>
          }
          <input
            type="text"
            [placeholder]="question().placeholder || '' | translate"
            matInput
            [formControl]="autocompleteControl"
            [matAutocomplete]="cropVarietyAutocomplete"
            data-test="dropdown-select"
          />
          <mat-autocomplete
            #cropVarietyAutocomplete="matAutocomplete"
            [displayWith]="displayTranslatedValue"
            (optionSelected)="updateRadioOrDropDownValue($event)"
          >
            @for (option of filteredOptions$ | async; track option) {
              <mat-option [value]="option.value" [attr.data-key]="option.key" data-test="dropdown-select-option">
                {{ option.value | translate }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    } @else if (
      question().controlType === 'radio-button' && (question().isVisible || question().isVisible === undefined)
    ) {
      <div class="mat-input-group-wrapper" data-test="radio-button-question-wrapper">
        <h4 class="margin-5" [class.invalid-label]="getRequiredTag() && isInvalidRequired()" data-test="question-label">
          {{ (question().label | translate).concat(getRequiredTag()) }}
        </h4>
        @if (question().description && question().description !== undefined) {
          <p class="description-text" data-test="question-description">
            {{ question().description! | translate }}
          </p>
        }
        <mat-radio-group
          data-test="radio-button-question"
          class="mat-radio-group-wrapper full-width-input"
          [formControl]="getFormControl(question().key)"
        >
          @for (opt of question().options; track opt.key) {
            <div
              class="radio-button-container"
              [class.selected]="formGroup().get(question().key)?.value === opt.key"
              [matTooltip]="readOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
              [matTooltipDisabled]="!readOnly()"
            >
              <mat-radio-button
                class="mat-radio-button"
                color="primary"
                [value]="opt.key"
                (change)="updateRadioOrDropDownValue($event)"
                [attr.data-test]="'radio-option-' + opt.key"
              >
                {{ opt.value | translate }}
              </mat-radio-button>
            </div>
          }
        </mat-radio-group>
        @if (question().cropFieldSpecificResults) {
          <div class="information-text" data-test="information-text">
            {{ '* ' + ('TGA.Questionnaire.Generic.Soil.CropFieldSpecificResults' | translate) }}
          </div>
        }
      </div>
    } @else if (question().controlType === 'number' && (question().isVisible || question().isVisible === undefined)) {
      <div class="mat-input-group-wrapper" data-test="number-question-wrapper">
        <h4
          class="margin-10"
          [class.invalid-label]="getRequiredTag() && isInvalidRequired()"
          data-test="question-label"
        >
          {{ (question().label | translate).concat(getRequiredTag()) }}
        </h4>
        @if (question().description && question().description !== undefined) {
          <p class="description-text" data-test="question-description">
            {{ question().description! | translate }}
          </p>
        }
        <mat-form-field
          class="full-width-input"
          [matTooltip]="readOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [matTooltipDisabled]="!readOnly()"
        >
          <mat-label>
            {{ question().placeholder || '' | translate }}
          </mat-label>
          <input
            matInput
            agrNumber
            maxlength="10"
            autocomplete="off"
            [formControlName]="question().key"
            data-test="number-input-question"
            (input)="updateNumberValue($event)"
          />
          @if (getFormControl(question().key).hasError('range')) {
            <mat-error class="error" data-test="number-range-error">
              {{ getFormControl(question().key).getError('range')?.message }}
            </mat-error>
          } @else if (getFormControl(question().key).hasError('invalidNumber')) {
            <mat-error class="error" data-test="number-invalid-error">
              {{ getFormControl(question().key).getError('invalidNumber')?.message }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    } @else if (
      question().controlType === 'free-text' && (question().isVisible || question().isVisible === undefined)
    ) {
      <div class="mat-input-group-wrapper" data-test="free-text-question-wrapper">
        <h4
          class="margin-10"
          [class.invalid-label]="getRequiredTag() && isInvalidRequired()"
          data-test="question-label"
        >
          {{ (question().label | translate).concat(getRequiredTag()) }}
        </h4>
        @if (question().description && question().description !== undefined) {
          <p class="description-text" data-test="question-description">
            {{ question().description! | translate }}
          </p>
        }
        <mat-form-field
          class="full-width-input"
          [matTooltip]="readOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [matTooltipDisabled]="!readOnly()"
        >
          <mat-label>
            {{ question().placeholder || '' | translate }}
          </mat-label>
          <input
            matInput
            maxlength="500"
            [formControlName]="question().key"
            data-test="text-input-question"
            (input)="updateTextValue($event)"
          />
        </mat-form-field>
      </div>
    } @else if (
      question().controlType === 'date-year' && (question().isVisible || question().isVisible === undefined)
    ) {
      <div class="mat-input-group-wrapper" data-test="free-text-question-wrapper">
        <h4
          class="margin-10"
          [class.invalid-label]="getRequiredTag() && isInvalidRequired()"
          data-test="question-label"
        >
          {{ (question().label | translate).concat(getRequiredTag()) }}
        </h4>
        @if (question().description && question().description !== undefined) {
          <p class="description-text" data-test="question-description">
            {{ question().description! | translate }}
          </p>
        }
        <mat-form-field
          appearance="outline"
          [matTooltip]="readOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [matTooltipDisabled]="!readOnly()"
        >
          <mat-label>{{ (question().placeholder || '' | translate).concat(getRequiredTag()) }}</mat-label>
          <input
            matInput
            [placeholder]="question().placeholder || '' | translate"
            [min]="asDateYearQuestion().range.min"
            [max]="asDateYearQuestion().range.max"
            [matDatepicker]="datePicker"
            [formControlName]="question().key"
            (focus)="datePicker?.open()"
            (input)="onYearSelected(question().key, $event, datePicker)"
          />
          <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
          <mat-datepicker
            #datePicker
            color="primary"
            startView="multi-year"
            (yearSelected)="onYearSelected(question().key, $event, datePicker)"
            [startAt]="asDateYearQuestion().range.min"
          ></mat-datepicker>
          <mat-error></mat-error>
        </mat-form-field>
      </div>
    } @else if (question().controlType === 'table' && (question().isVisible || question().isVisible === undefined)) {
      <div class="table-question-wrapper" data-test="table-question-wrapper">
        <div class="table-container">
          <h4
            class="table-title"
            [class.invalid-label]="getRequiredTag() && isInvalidRequired()"
            data-test="table-question-title"
          >
            {{ (question().label | translate).concat(getRequiredTag()) }}
          </h4>
          @if (question().description && question().description !== undefined) {
            <p class="description-text" data-test="question-description">
              {{ question().description! | translate }}
            </p>
          }
          <div class="table-content">
            @for (subQuestion of asTableQuestion().subQuestions; track subQuestion.key) {
              <div class="table-row">
                <div class="table-cell question-cell">
                  <span class="question-text" [class.bold-text]="isWarningMessageQuestion(subQuestion)">
                    {{ subQuestion.label | translate }}
                  </span>
                </div>
                <div class="table-cell input-cell">
                  <app-question-form
                    [question]="subQuestion"
                    [formGroup]="formGroup()"
                    [readOnly]="readOnly()"
                    (valueChanged)="valueChanged.emit($event)"
                  />
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</agr-form>
